import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert } from '../../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import { DispatchCenterService } from '../../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService } from '../../../shared/layout/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../../reports/reports-service/report.service';
import { FilterByKeyPipe } from 'src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../../service-areas/service-areas-service/service-areas.service';
import { checkRole, isNotCurrentDateTrip } from 'src/app/utils/utils.common';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { PlanningAreasWiseService } from 'src/app/service/planning-services/planning-areaswise-service';
import { PlannerNearbyWiseService } from 'src/app/service/planning-services/planning-nearbywise-service';
@Component({
  selector: 'app-planner',
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.css']
})
export class PlannerComponent implements OnInit {
  @ViewChild("timer", { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  filterdataList = [];
  todayDate;
  status = "unassigned";
  isShowAllTrips = false;
  isTimerEnabled = false;
  search: any;
  timeZone;
  specialRate;
  user;
  selectedTrip;
  selectedTrips = [];
  skip = 0;
  selectedTripId;
  isAllTripsSelected: boolean = false;
  scheduleTripObj;
  selectedTripPurpose = '';
  selectedLOS = '';
  selectedSpaceType = '';
  selectedAptType = '';
  selectedServiceArea = '';
  selectedCooperate = "";
  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];
  appointmentTypes;
  showSlideFilter = false;
  patients;
  selectedPatient = "";
  isTemplateModal = false;
  isAllowRates = false;

  fleets = [];
  drivers = [];
  timeRange;
  filterType: 'greater' | 'less' = 'greater';
  mileThreshold = '';
  mileOptions = [5, 10, 15, 20];
  minMiles:any = 0;
  maxMiles:any = 0;

  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';


  constructor(
    private socketService: SocketService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private fleetService: FleetService,
    private driverService: DriversService,
    private plannerNearbyWiseService: PlannerNearbyWiseService,


  ) { }

  ngOnInit() {
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.getUser();
    this.listenSocket();

    this.driverService
    .getDrivers(this.user._id, 'active')
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.drivers = data;

      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });

    this.fleetService
    .getFleetList({ 'isFleetSection': true, 'status': 'active' })
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.fleets = data;
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }


  reset() {
    this.selectedTrips = [];
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data ) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({status: 'active'})
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({status: 'active'})
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: 'active'})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          // this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.todayDate = moment.tz(this.timeZone).startOf("day").toISOString();
          this.timeRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getTrips();
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTrips() {
    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.timeRange,
      skip: this.skip,
    };
    // this.store.dispatch(new GetUnassignedList(object));
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            // this.search = '';
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            const maxMilesTrip = Math.max(...this.filterdataList.map(trip => trip.milage || 0));
            this.maxMiles = maxMilesTrip ? maxMilesTrip.toFixed(0) : 0;

            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;
              if (this.timer && this.status === 'unassigned') {
                if (this.isTimerEnabled)
                  this.timer.start();
              }
              let cooperates = [];
              let levelOfServices = [];
              let spaceTypes = [];
              let serviceAreas = [];
              this.appointmentTypes = [];
              this.patients = [];

              this.dataList.forEach(trip => {
                if (trip.cooperate) {
                  cooperates.push(trip.cooperate);
                }

                if (trip.los) {
                  levelOfServices.push(trip.los);
                }

                if (trip.spaceType) {
                  spaceTypes.push(trip.spaceType);
                }

                if (trip.tripReason) {
                  // remove the item having empty string
                  if (trip.tripReason && trip.tripReason.length) {
                    this.appointmentTypes.push(...trip.tripReason);
                  }
                }
                  if(trip.serviceArea){
                    serviceAreas.push(trip.serviceArea);
                  }

                  if (trip.priorityClient) {
                    this.patients.push({ displayName: trip.priorityClient.displayName });
                  }
              });

                if (this.selectedLOS)
                levelOfServices.push(this.selectedLOS)

                if (this.selectedSpaceType)
                spaceTypes.push(this.selectedSpaceType)

                if (this.selectedServiceArea)
                serviceAreas.push(this.selectedServiceArea)

                if (this.selectedAptType)
                this.appointmentTypes.push(this.selectedAptType)

                if (this.selectedPatient)
                this.patients.push(this.selectedPatient)


              cooperates = _.uniq(cooperates).sort();
              levelOfServices = _.uniq(levelOfServices).sort();
              spaceTypes = _.uniq(spaceTypes).sort();
              serviceAreas =  _.uniq(serviceAreas).sort();
              this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
              this.patients = _.uniq(this.patients, 'displayName').sort();

              if(cooperates && cooperates.length){
                this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
              }

              if(levelOfServices && levelOfServices.length){
                this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
              }

              if(serviceAreas && serviceAreas.length){
                this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
              }

              if(spaceTypes && spaceTypes.length){
                this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
              }

            }
          } else if (this.timer && this.status === 'unassigned') {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {

        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    this.todayDate = event.toISOString();
    this.timeRange = [
      event.startOf("day").toISOString(),
      event.endOf("day").toISOString(),
    ];
    this.getTrips();
  }


  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    this.timeRange = [
      event[0].toISOString(),
      event[1].toISOString(),
    ]
    this.getTrips();
  }

  onSelectTrip(trip) {
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      if (assign.issues && assign.issues.length) {
        return;
      }
      assign.isSelected = true;
      if(!this.selectedTrips.includes(assign._id))
      this.selectedTrips.push(assign._id);
    });
    // }

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
    this.filterByMiles();
  }


  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;

      if (trip.spaceType && this.selectedSpaceType && this.selectedSpaceType.length) {
        isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
      }

      if (trip.priorityClient && trip.priorityClient.displayName && this.selectedPatient && this.selectedPatient.length) {
        isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
      }

      if (trip.tripReason && this.selectedAptType && this.selectedAptType.length) {
        isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
      }

      if (trip.cooperate && this.selectedCooperate && this.selectedCooperate.length) {
        isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
      }

      if (trip.los && this.selectedLOS && this.selectedLOS.length) {
        islosExist = this.selectedLOS.includes(trip.los);
      }

      if (trip.serviceArea && this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
      }

      if (isSpaceTypeExist && isAptTypeExist && isCorporateExist && islosExist && isServiceAreaExist && isPatientExist) {
        return true;
      } else {
        return false;
      }
    });
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  ngOnDestroy(): void {
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  // scheduleTrip(selectedTrips) {
  //   const payload = this.plannerNearbyWiseService.getGroupedClientNames(this.drivers, this.plannerNearbyWiseService.assignTripsToDrivers(this.dataList, this.drivers, this.fleets));
  //   console.log(payload);
  //   // this.scheduleTripObj = {selectedTrips, date:this.todayDate, spaceTypes:this.preSpaceTypes, trips: this.filterdataList, preCooperates: this.preCooperates, preLevelOfServices :  this.preLevelOfServices};

  //   return;
  //   this.assignTripService.liveTripsForMultipleDriver({data: payload}).subscribe((data) => {
  //     if (data) {
  //       sweetAlert('Alert', 'Published all', 'warning', 'OK')
  //     }
  //   }, err => {
  //     sweetAlert('Error', err, 'warning', 'OK');
  //   })


  // }

  scheduleTrip(selectedTrips){
    this.scheduleTripObj = {selectedTrips, date:this.todayDate, spaceTypes:this.preSpaceTypes, trips: this.dataList, preCooperates: this.preCooperates, preLevelOfServices :  this.preLevelOfServices};
  }

  reFreshCall(evt) {
    this.scheduleTripObj = null;
    this.selectedTrips = []
    this.getTrips();
  }

  templateModal(){
    this.isTemplateModal = true;
  }

  isNotCurrentDateTrip(trip) {
   return isNotCurrentDateTrip(trip,this.timeZone)
  }

    onResetTime() {
      this.reset();
      this.skip = 0;
      this.clearTrips();

       this.timeRange  = [
        moment(this.todayDate).startOf("day").toISOString(),
        moment(this.todayDate).endOf("day").toISOString(),
      ];

      this.getTrips();
    }

  getTimeRestrictions() {
    return {
      min: moment(this.todayDate).startOf("day").toISOString(),
      max: moment(this.todayDate).endOf("day").toISOString()
    }
  }
  changeFilter(){
    if(this.filterType === 'greater') {
      this.filterType = 'less';
    }else{
      this.filterType = 'greater';
    }
}

  filterByMiles() {
    this.filterdataList = this.filterdataList.filter(trip => {
      const meetsMin = this.minMiles == null || trip.milage >= this.minMiles;
      const meetsMax = this.maxMiles == null || trip.milage <= this.maxMiles;
      return meetsMin && meetsMax;
    });
  }
}

